import InvoiceFourContainer from "../Component/Application/Ecommerce/Invoices/Invoice-4/Invoice-4";
import GestCarburant from "../Pages/BonDeCarburant";
import ShowCarburant from "../Pages/BonDeCarburant/carburantShow";
import NouveauBon from "../Pages/BonDeCommande/add";
import ShowBons from "../Pages/BonDeCommande/show";
import GestCaisse from "../Pages/Caisse";
import Synthese from "../Pages/Caisse/synthese";
import GestFournisseur from "../Pages/Fournisseurs";
import GestInfoEts from "../Pages/InfosEts";
import GestProduits from "../Pages/Produits";
import ShowProduits from "../Pages/Produits/showProduit";
import GestRoles from "../Pages/Roles";
import SamplePage from "../Pages/SamplePage/SamplePage";
import GestUsers from "../Pages/Utilisateurs";
import GestVentes from "../Pages/Ventes";
import CheckoutContainer from "../Pages/Ventes/Checkout";
import VentesRapportHistorique from "../Pages/Ventes/Rapports";
import GestVersementsV2 from "../Pages/versements_v2";
import AddVersementV2 from "../Pages/versements_v2/add";
import ShowVersementsV2 from "../Pages/versements_v2/showVersement";
import GestBonsA from "../Pages/BonDeCommande/index_b";
import ProfileCard from "../Pages/Profile";
import GestAutresVersement from "../Pages/versements_v2/Autres/Index";
import AddAutresVersements from "../Pages/versements_v2/Autres/add";
import ShowAutresVersement from "../Pages/versements_v2/Autres/show";
import NouveauAutresBon from "../Pages/BonDeCommande/Autres/add";
import ShowAutresBons from "../Pages/BonDeCommande/Autres/show";
import GestBonsAutres from "../Pages/BonDeCommande/Autres/index";
import GestClients from "../Pages/Clients";
import ShowClients from "../Pages/Clients/show";
import FactureRecu from "../Pages/Factures";
import ShowFactures from "../Pages/Factures/showFactures";
import ShowRecu from "../Pages/Factures/showRecu";
import GestPDV from "../Pages/PDV";
import ShowPDV from "../Pages/PDV/show";
import RHMouvement from "../Pages/Ventes/Rapports/Mouvements";
import RHVentes from "../Pages/Ventes/Rapports/Ventes";

const routes = [
  // Sample Page
  { path: `${process.env.PUBLIC_URL}/pages/samplepage`, Component: <SamplePage /> },
  // Users
  { path: `${process.env.PUBLIC_URL}/gestion-utilisateur`, Component: <GestUsers /> },
  { path: `${process.env.PUBLIC_URL}/mon-profil`, Component: <ProfileCard /> },
  // Roles
  { path: `${process.env.PUBLIC_URL}/gestion-roles`, Component: <GestRoles /> },
  // Informations 
  { path: `${process.env.PUBLIC_URL}/gestion-infos-ets`, Component: <GestInfoEts /> },
  // Fournisseurs
  { path: `${process.env.PUBLIC_URL}/gestion-fournisseur`, Component: <GestFournisseur /> },
  // Versements V2
  { path: `${process.env.PUBLIC_URL}/gestion-versements`, Component: <GestVersementsV2 /> },
  { path: `${process.env.PUBLIC_URL}/ajouter-un-versements`, Component: <AddVersementV2 /> },
  { path: `${process.env.PUBLIC_URL}/show-versement/:id`, Component: <ShowVersementsV2 /> },
  { path: `${process.env.PUBLIC_URL}/autres-versement`, Component: <GestAutresVersement /> },
  { path: `${process.env.PUBLIC_URL}/ajouter-autres-versement`, Component: <AddAutresVersements /> },
  { path: `${process.env.PUBLIC_URL}/show-autres-versement/:id`, Component: <ShowAutresVersement /> },
  // { path: `${process.env.PUBLIC_URL}/materiel`, Component: <GestMateriel /> },

  // Bons de commande
  { path: `${process.env.PUBLIC_URL}/bon-de-commande`, Component: <GestBonsA /> },
  { path: `${process.env.PUBLIC_URL}/autres-bon-de-commande`, Component: <GestBonsAutres /> },
  { path: `${process.env.PUBLIC_URL}/nouveau-bon-de-commande`, Component: <NouveauBon /> },
  { path: `${process.env.PUBLIC_URL}/nouveau-autres-bon-de-commande`, Component: <NouveauAutresBon /> },
  { path: `${process.env.PUBLIC_URL}/show-bon-de-commande/:id`, Component: <ShowBons /> },
  { path: `${process.env.PUBLIC_URL}/show-autres-bon-de-commande/:id`, Component: <ShowAutresBons /> },
  // Bon de Carburant
  { path: `${process.env.PUBLIC_URL}/bon-de-carburant`, Component: <GestCarburant /> },
  { path: `${process.env.PUBLIC_URL}/show-bon-de-carburant/:id`, Component: <ShowCarburant /> },
  // Produits
  { path: `${process.env.PUBLIC_URL}/produits`, Component: <GestProduits /> },
  { path: `${process.env.PUBLIC_URL}/produits-show/:id`, Component: <ShowProduits /> },
  // Ventes
  { path: `${process.env.PUBLIC_URL}/ventes`, Component: <GestVentes /> },
  { path: `${process.env.PUBLIC_URL}/checkout`, Component: <CheckoutContainer /> },
  { path: `${process.env.PUBLIC_URL}/vente-facture/:id`, Component: <InvoiceFourContainer /> },
  { path: `${process.env.PUBLIC_URL}/ventes-historique`, Component: <VentesRapportHistorique /> },
  { path: `${process.env.PUBLIC_URL}/historique-des-ventes`, Component: <RHVentes/>},
  { path: `${process.env.PUBLIC_URL}/mouvements-stock`, Component: <RHMouvement/>},

  // Caisse
  { path: `${process.env.PUBLIC_URL}/caisses`, Component: <GestCaisse /> },
  { path: `${process.env.PUBLIC_URL}/synthese-caisse`, Component: <Synthese /> },
  { path: `${process.env.PUBLIC_URL}/factures`, Component: <FactureRecu /> },
  { path: `${process.env.PUBLIC_URL}/factures/show/:id`, Component: <ShowFactures /> },
  { path: `${process.env.PUBLIC_URL}/factures/recus/show/:id`, Component: <ShowRecu /> },

  // Clients
  { path: `${process.env.PUBLIC_URL}/Clients`, Component: <GestClients /> },
  { path: `${process.env.PUBLIC_URL}/Clients/details/:id`, Component: <ShowClients /> },

  // PDV
  { path: `${process.env.PUBLIC_URL}/points-de-ventes`, Component: <GestPDV /> },
  { path: `${process.env.PUBLIC_URL}/points-de-ventes/details/:id`, Component: <ShowPDV /> },
]

export default routes;